import React, { useState, useEffect } from "react";
import UserInput from "./UserInput";
import Plan from "./Plan";
import Code from "./Code";
import Output from "./Output";
import "./PolonyApp.css"
import Messages from "./Messages";
import primeData from '../data/prime_heights_aus.json';
import primeMinisterData from '../data/prime_minister.json';
import audUsdData from '../data/aud_usd.json';
import Browse from "./Browse";
import ChatgptResponse from "./ChatgptResponse";

function PolonyApp() {
  const [workData, setWorkData] = useState({});
  const [messages, setMessages] = useState([]);
  const [messageData, setMessageData] = useState([]);
  const [inputOptions, setInputOptions] = useState([]);
  const [timeoutIds, setTimeoutIds] = useState([]);
  const timeBetweenThoughts = 800;

  useEffect(() => {
    setMessageData([
      primeData, primeMinisterData, audUsdData
    ]);
  }, []);

  useEffect(() => {
    setInputOptions(
      messageData.map(o => o.user_command)
    );
  }, [messageData]);

  const handleWorkUpdate = (newData) => {
    setWorkData(prevData => ({
      ...prevData,
      ...newData
    }));
  };

  const handleSendClick = (inputText) => {
    handleResetClick();
    const incomingMessages = messageData.find(o => o.user_command === inputText);
    if (incomingMessages) {
      handleWorkUpdate({ chatgptResponse: "Thinking..." });
      handleWorkUpdate({ output: {out: "Thinking..." }});
      incomingMessages.messages.forEach((data, index) => {
        const timeoutId = setTimeout(() => {
          switch (data.message_type) {
            case "notify":
              setMessages(prevMessages => [...prevMessages, data.data]);
              break;
            case "plan":
              handleWorkUpdate({ plan: data.data.plan });
              break;
            case "output":
              handleWorkUpdate({ output: data.data });
              break;
            case "code":
              handleWorkUpdate({ code: data.data.code });
              break;
            case "browse":
              handleWorkUpdate({ browse: data.data});
              break;
            default:
              console.error("Unhandled message type:", data.message_type);
              break;
          }
        }, index * timeBetweenThoughts);
        setTimeoutIds(prevTimeoutIds => [...prevTimeoutIds, timeoutId]);
      });
      const timeoutId = setTimeout(() => {
        handleWorkUpdate({ chatgptResponse: incomingMessages.chatgpt_response });
      }, (incomingMessages.messages.length + 1) * timeBetweenThoughts);
        setTimeoutIds(prevTimeoutIds => [...prevTimeoutIds, timeoutId]);
    }
  };

  const clearTimeouts = () => {
    timeoutIds.forEach(id => clearTimeout(id));
    setTimeoutIds([]);
  };

  const handleResetClick = () => {
    clearTimeouts();
    setMessages([]);
    setWorkData({});
  };

  return (
    <div className="PolonyApp">
      <h1 className='darkheader'>Polony AI</h1>
      <div className="PolonyBody">
        <UserInput onSendClick={handleSendClick} onResetClick={handleResetClick} inputOptions={inputOptions} />
        <Plan data={workData.plan} />
        <Code data={workData.code} />
        <Output data={workData.output} />
        <Browse data={workData.browse} />
        <ChatgptResponse data={workData.chatgptResponse} />
        <Messages data={workData.message} messages={messages} setMessages={setMessages} />
      </div>
    </div>
  );
}

export default PolonyApp;
